import React, { useLayoutEffect } from 'react';
import {
  FaqPage,
  FaqContainer,
  FaqSection,
  FaqSectionTitle,
  AccordionsWrapper,
  Accordion,
  AccordionSummary,
  AccordionContent,
} from './FAQ.styles';
import { SectionTitle } from '../projects/hiking/Hiking.styles';

export const FAQ: React.FC = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FaqPage>
      <SectionTitle large>FAQ</SectionTitle>
      <FaqContainer>
        <FaqSection>
          <FaqSectionTitle>PRZED WYJAZDEM</FaqSectionTitle>
          <AccordionsWrapper>
            <Accordion>
              <AccordionSummary>Jak się zapisać?</AccordionSummary>
              <AccordionContent>
                Napisz do nas przez maila, telefon lub Messenger – podaj imię, nazwisko i numer
                telefonu. Prześlemy Ci dane do przelewu. Czekamy na wpłatę 3 dni robocze – po tym
                czasie, jeśli nie dostaniemy przelewu ani informacji, zwalniamy miejsce.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Harmonogram wpłat</AccordionSummary>
              <AccordionContent>
                <ul style={{ margin: '0 0 0 20px' }}>
                  <li>Zadatek (30% całej kwoty) – wpłać w ciągu 3 dni od zgłoszenia.</li>
                  <li>Reszta kwoty – najpóźniej 21 dni przed wyjazdem.</li>
                </ul>
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Co jeśli nie zapłacę na czas?</AccordionSummary>
              <AccordionContent>
                Jeśli masz trudność z terminem wpłaty – daj znać. Zazwyczaj da się coś ustalić
                indywidualnie.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Czy liczba miejsc jest ograniczona?</AccordionSummary>
              <AccordionContent>
                Tak. Obowiązuje kolejność zgłoszeń. Liczba miejsc jest stała – nie zwiększamy grupy.
                Jeśli nie zdążysz, możesz dołączyć do listy rezerwowej.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Co jeśli zrezygnuję?</AccordionSummary>
              <AccordionContent>
                <ul style={{ margin: '0 0 0 20px' }}>
                  <li>Zadatek jest bezzwrotny.</li>
                  <li>Możesz przekazać miejsce innej osobie – po potwierdzeniu przez nas.</li>
                  <li>
                    Rezygnując najpóźniej 21 dni przed wyjazdem, zwracamy pozostałą kwotę (bez
                    zadatku).
                  </li>
                  <li>Po tym terminie – nie zwracamy kosztów.</li>
                </ul>
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Czy wyjazd na pewno się odbędzie?</AccordionSummary>
              <AccordionContent>
                Wyjazd rusza od min. 2 uczestniczek. Jeśli grupa się nie zbierze, poinformujemy Cię
                najpóźniej 21 dni przed wyprawą, wówczas:
                <ul style={{ margin: '8px 0 0 20px' }}>
                  <li>zwrócimy 100% wpłat,</li>
                  <li>albo przeniesiemy Cię na inny termin – jeśli wyrazisz zgodę.</li>
                </ul>
              </AccordionContent>
            </Accordion>
          </AccordionsWrapper>
        </FaqSection>

        <FaqSection>
          <FaqSectionTitle>LOTY I ZMIANY</FaqSectionTitle>
          <AccordionsWrapper>
            <Accordion>
              <AccordionSummary>Co jeśli zmienią się loty lub zostaną odwołane?</AccordionSummary>
              <AccordionContent>
                To zależy od linii lotniczych – nie mamy na to wpływu. Jeśli tylko będzie to
                możliwe:
                <ul style={{ margin: '8px 0 0 20px' }}>
                  <li>dostosujemy plan wyprawy,</li>
                  <li>
                    jeśli wyjazd okaże się niemożliwy do zrealizowania, zaproponujemy alternatywę
                    lub zwrot środków z uwzględnieniem poniesionych kosztów organizacyjnych.
                  </li>
                </ul>
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Co jeśli to my odwołamy wyjazd?</AccordionSummary>
              <AccordionContent>
                Zdarza się rzadko, ale jeśli np. pogoda, sytuacja lokalna, brak grupy lub inne
                czynniki nas do tego zmuszą:
                <ul style={{ margin: '8px 0 0 20px' }}>
                  <li>zwracamy 100% wpłaconych środków,</li>
                  <li>lub – jeśli chcesz – przenosimy Cię na inną wyprawę.</li>
                </ul>
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Na co nie mamy wpływu?</AccordionSummary>
              <AccordionContent>
                Loty, pogoda (chociaż kto wie ten wie), sytuacje losowe, decyzje lokalnych służb –
                mogą wpłynąć na plan. Ale spokojnie – jesteśmy elastyczne i znajdziemy bezpieczne
                rozwiązanie.
              </AccordionContent>
            </Accordion>
          </AccordionsWrapper>
        </FaqSection>

        <FaqSection>
          <FaqSectionTitle>W TRAKCIE WYPRAWY</FaqSectionTitle>
          <AccordionsWrapper>
            <Accordion>
              <AccordionSummary>Co jeśli nie będzie pogody?</AccordionSummary>
              <AccordionContent>
                Bezpieczeństwo to podstawa – nie idziemy w góry za wszelką cenę. Mamy plan B – inne
                atrakcje i aktywności, które pozwolą Ci wrócić z dobrymi wspomnieniami.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Gdzie będziemy jeść?</AccordionSummary>
              <AccordionContent>
                Wybieramy niedrogie i klimatyczne restauracje – decyzję podejmujemy wspólnie. W
                niektórych miejscach (np. Dolomity) gotujemy razem.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Co jeśli ulegnę kontuzji w trakcie wyjazdu?</AccordionSummary>
              <AccordionContent>
                Reagujemy spokojnie i adekwatnie.
                <ul style={{ margin: '8px 0 0 20px' }}>
                  <li>Udzielimy pierwszej pomocy.</li>
                  <li>W razie potrzeby pomożemy z transportem lub służbami.</li>
                  <li>
                    Jeśli nie możesz kontynuować – pomożemy Ci zaplanować alternatywne aktywności.
                  </li>
                </ul>
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Czy będzie spotkanie przed wyjazdem?</AccordionSummary>
              <AccordionContent>
                Tak! Spotkanie zapoznawcze organizujemy, gdy zbierze się grupa. Odpowiadamy wówczas
                na wszelkie pytania i dajemy okazję do poznania się przed wspólną przygodą :)
              </AccordionContent>
            </Accordion>
          </AccordionsWrapper>
        </FaqSection>

        <FaqSection>
          <FaqSectionTitle>ZDROWIE I BEZPIECZEŃSTWO</FaqSectionTitle>
          <AccordionsWrapper>
            <Accordion>
              <AccordionSummary>Jakie są przeciwwskazania zdrowotne?</AccordionSummary>
              <AccordionContent>
                Udział w wyprawie zakłada dobrą ogólną kondycję fizyczną – dziennie pokonujemy nawet
                15–25 km w terenie górskim. Niektóre dolegliwości (np. problemy z kolanami,
                kręgosłupem, przewlekłe choroby) nie muszą wykluczać udziału, ale wymagają
                konsultacji z lekarzem prowadzącym. Dla bezpieczeństwa wszystkich – prosimy, by
                każda uczestniczka indywidualnie oceniła, czy plan wyjazdu jest odpowiedni dla jej
                zdrowia.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Mam chorobę przewlekłą – co wtedy?</AccordionSummary>
              <AccordionContent>
                Daj nam znać wcześniej – np. przy cukrzycy, astmie, problemach z sercem czy
                tarczycą. Dzięki temu będziemy mogły lepiej zadbać o Twoje bezpieczeństwo.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Co obejmuje ubezpieczenie?</AccordionSummary>
              <AccordionContent>
                Wykupujemy dla każdej uczestniczki obowiązkowe ubezpieczenie turystyczne (NNW + OC).
                To warunek udziału w wyjeździe. Szczegóły (w tym OWU) prześlemy przed wyjazdem –
                zachęcamy do zapoznania się z zakresem ochrony.
              </AccordionContent>
            </Accordion>
            <Accordion>
              <AccordionSummary>Ważne informacje organizacyjne</AccordionSummary>
              <AccordionContent>
                Nie jesteśmy firmą ani organizatorem turystyki w rozumieniu ustawy o imprezach
                turystycznych. Wyjazdy realizujemy jako prywatna, nieformalna grupa. Udział w
                wyjeździe jest dobrowolny i każda uczestniczka bierze w nim udział na własną
                odpowiedzialność.
              </AccordionContent>
            </Accordion>
          </AccordionsWrapper>
        </FaqSection>
      </FaqContainer>
    </FaqPage>
  );
};
export default FAQ;
